import { Text, Title } from '@components/v2/ui';
import {
	Flex,
	NumberFormatter,
	Stack,
} from '@mantine/core';
import Decimal from 'decimal.js';
import { useTranslation } from 'react-i18next';

export const AdditionalitiesOffsetSummary = ({
	total,
}: {
	total: number;
}) => {
	const formattedTotal = new Decimal(total)
		.toDecimalPlaces(3)
		.toString();

	const { t } = useTranslation();
	return (
		<Stack w="100%" gap="24px">
			<Stack gap="0">
				<Flex justify="space-between" align="center">
					<Text
						variant="subtitle1"
						c="var(--mantine-color-igluTextPrimary-9)"
					>
						{t('global.total')} :
					</Text>
					<Title
						order={6}
						c="var(--mantine-color-igluBlue-9)"
					>
						<NumberFormatter
							thousandSeparator=" "
							decimalSeparator=","
							value={formattedTotal}
							decimalScale={2}
							suffix="€"
						/>
					</Title>
				</Flex>
			</Stack>
		</Stack>
	);
};
